import "./views/concessions/partials/_theatersByLocation.js";
import "./views/concessions/partials/_theatersPlaceholder.js";
import "./views/fd-pkgs/@fd-assets/carousel/shared/partials/_movieCarousel.js";
import "./views/fd-pkgs/fd-location/partials/_locationDropdown.js";